import {
  GreyGrey60,
  GreyGrey70,
  GreyGrey80,
  Pill,
  Popover,
  Portal,
  Primary13Regular,
  IconPeopleCircle,
  Box,
  Flex,
  Grid
} from '@sequencehq/core-components'
import { FC, ReactNode } from 'react'

export type BillingContactPill = {
  id: string
  email: string
  name?: string
}

type Props = {
  contacts: BillingContactPill[]
  'data-testid'?: string
}

export const BillingContactsPills: FC<Props> = ({
  contacts,
  'data-testid': dataTestId
}) => {
  const [firstContact] = contacts

  if (!firstContact) {
    return null
  }

  return (
    <BillingContactsPopover
      contacts={contacts}
      trigger={
        <Box position="relative" data-testid={dataTestId}>
          <Pill
            interactive
            more={contacts.length > 1 ? contacts.length - 1 : undefined}
          >
            <Flex gap="8px" alignItems="center">
              <IconPeopleCircle color={GreyGrey70} />
              {firstContact.email}
            </Flex>
          </Pill>
        </Box>
      }
    />
  )
}

const BillingContactsPopover: FC<{
  contacts: BillingContactPill[]
  trigger: ReactNode
}> = ({ contacts, trigger }) => {
  return (
    <Popover.Root trigger="hover" openDelay={250} placement="bottom-start">
      <Popover.Trigger>{trigger}</Popover.Trigger>
      <Portal>
        <Popover.Content width="fit-content" minWidth="200px">
          <Box padding="8px 8px 0">
            {contacts.map(contact => (
              <Grid
                key={contact.id}
                templateColumns="auto auto 1fr"
                paddingBottom="8px"
                gap="4px"
                {...Primary13Regular}
              >
                <Box paddingRight="4px">
                  <IconPeopleCircle color={GreyGrey70} />
                </Box>
                <Box color={GreyGrey80}>{contact.name}</Box>
                <Box color={GreyGrey60}>{contact.email}</Box>
              </Grid>
            ))}
          </Box>
        </Popover.Content>
      </Portal>
    </Popover.Root>
  )
}
